/**
 * THE FLOOR'S OWN VOCABULARY, IN A MODULE THAT IMPORTS NOTHING.
 *
 * These two lists were declared in `slice.js` and are still exported from it,
 * so every existing importer is unchanged. They live here because the pure
 * liveness policy (`refreshSchedule.js`) has to read them, and reaching into
 * the slice for a constant drags `axiosInstance` and therefore axios's ESM
 * build into any suite that touches the policy, which this repo's jest
 * transform cannot parse. A list of four strings is not worth a second copy and
 * is not worth a mock either.
 */

/** The floor states that mean the squad's output IS IN (technical brief 5.3). */
export const FLOOR_IN = Object.freeze(["passed", "exempt"]);

/** Every floor state that is not still waiting on a result. */
export const FLOOR_TERMINAL = Object.freeze([
  "passed",
  "exempt",
  "failed",
  "manual_review",
]);
